import { getRequiredEnvValue } from '../env';
import { LayoutType, SizeType, FitType } from '../types/asset-types';

export const DEFAULT_AUDIO_CONTENT_MAGIC_LAYOUT = {
  // These should be default colors for custom upload audiogram
  backgroundColor: '#FF4200',
  backgroundImage: `${getRequiredEnvValue(
    'CLOUDFRONT_STATIC_ASSET_URL'
  )}content-lab/filestack/brand_kit/templates/background/background-1.png`,
  textColor: '#ffffff'
};
export const DEFAULT_MAGIC_LAYOUT = {
  backgroundColor: '#324bff',
  textColor: '#ffffff'
};
export const DEFAULT_LAYOUT_TYPE = 'GRID' as LayoutType;
export const DEFAULT_SIZE_TYPE = 'LANDSCAPE' as SizeType;
export const DEFAULT_FIT_TYPE = 'FIT' as FitType;
export const DEFAULT_HIDE_BORDERS = false;
